export default __webpack_public_path__ + "static/media/boxbg.84ff4460.jpg";